import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useMe } from '@/session/useSession';
import { useMyReferrals } from './api';
import { CouponBox } from './CouponBox';

const key = (userId: string) => `coupon-prompt:${userId}`;

function asked(userId: string) {
  try {
    return window.localStorage.getItem(key(userId)) === '1';
  } catch {
    return true; // no storage: do not insist
  }
}

/** Right after the first sign-in: "Alguém te indicou?" (asked once per person). */
export function CouponPrompt() {
  const me = useMe();
  const referrals = useMyReferrals();
  const [closed, setClosed] = useState(() => asked(me.user.id));
  const close = () => {
    try {
      window.localStorage.setItem(key(me.user.id), '1');
    } catch {
      // Private mode: it just asks again next time.
    }
    setClosed(true);
  };
  const open = !closed && Boolean(referrals.data?.canUseCoupon);
  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle>Alguém te indicou?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Se você recebeu um cupom, digite aqui. Quem te indicou ganha R$ 10 quando você assinar um
          plano, e você ganha R$ 5 de desconto na primeira fatura. Dá para usar depois também, até o
          primeiro pagamento.
        </Typography>
        <CouponBox onUsed={close} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Agora não</Button>
      </DialogActions>
    </Dialog>
  );
}
